import { useState, useEffect, useCallback } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import { ShowHideSubTable } from "../../components/ShowHideSubTable";
import {
  getVehicleFuelSubcategory,
  createVehicleFuelSubcategory,
  updateVehicleFuelSubcategory,
  deleteVehicleFuelSubcategory,
} from "../../../../../apis/Business/FuelVehicleApi";
import SubcategoryBox from "../../components/SubcategoryBox";
import { useInvalidateQuery } from "../../../../../components/InvalidateQueryContext";
import FuelVehicleTable from "./Table";
import fuelVehIcon from "../../../../../assets/design-revamp-company/category-icons/fuel_vehicle_icon.svg";

const FuelVehicle = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [customSubcategories, setCustomSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const { invalidateKey, resetKey } = useInvalidateQuery();
  const key = "add-new-fuel-vehicle-subcategory";
  const deleteKey = "delete-fuel-vehicle-subcategory";

  useEffect(() => {
    getVehicleFuelSubcategory({
      businessId: businessId,
      setCustomSubcategory: setCustomSubcategories,
    });
  }, [businessId]);

  const handleSaveSubcategory = (subcategoryData) => {
    if (subcategoryData.objectId) {
      updateVehicleFuelSubcategory(subcategoryData)
        .then(() => {
          setCustomSubcategories((prevSubcategories) =>
            prevSubcategories.map((sub) =>
              sub.id === subcategoryData.objectId ? subcategoryData : sub
            )
          );
        })
        .catch((err) => console.error(err));
    } else {
      createVehicleFuelSubcategory(subcategoryData)
        .then((newSubcategory) => {
          setCustomSubcategories((prevSubcategories) => [
            ...prevSubcategories,
            newSubcategory,
          ]);
        })
        .catch((err) => console.error(err));
    }
  };

  const handleInvalidateAndReset = useCallback(
    (setSubcategoryCustom, setSubcategoryDescCustom, isNewSubcategory) => {
      if (invalidateKey === key || invalidateKey === deleteKey) {
        getVehicleFuelSubcategory({
          businessId: businessId,
          setCustomSubcategory: setCustomSubcategories,
        });
        if (isNewSubcategory) {
          setSubcategoryCustom("");
          setSubcategoryDescCustom("");
        }
      }
      resetKey();
    },
    [businessId, resetKey, invalidateKey, key, deleteKey]
  );

  useEffect(() => {
    handleInvalidateAndReset(
      () => {},
      () => {}
    );
  }, [invalidateKey, businessId, handleInvalidateAndReset]);

  const handleDeleteSubcategory = (subcategoryData) => {
    deleteVehicleFuelSubcategory(subcategoryData)
      .then(() => {
        setCustomSubcategories((prevSubcategories) =>
          prevSubcategories.filter((sub) => sub.id !== subcategoryData.objectId)
        );
      })
      .catch((err) => console.error(err));
  };

  const handleEditSubcategory = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };
  return (
    <div className="component-energy-contents">
      <SubHeaderBox
        subTitle={t("CAR_FUEL_FILL")}
        subDescription={t("CAR_FUEL_FILL_DESC")}
        icon={fuelVehIcon}
        number="2.5.2"
        isNormal={true}
      />

      <div style={{ marginTop: "12px" }}>
        <SubcategoryBox
          businessId={businessId}
          createSubcategoryApi={handleSaveSubcategory}
          handleInvalidateAndReset={handleInvalidateAndReset}
          isNewSubcategory={true}
        />

        {Array.isArray(customSubcategories) &&
          customSubcategories.length > 0 &&
          customSubcategories.map((sub, index) => {
            return (
              <div style={{ position: "relative" }}>
                <SubcategoryBox
                  key={sub.id}
                  subcategory={sub.name}
                  subcategoryDesc={sub.description}
                  subcategoryId={sub.id}
                  businessId={businessId}
                  createSubcategoryApi={createVehicleFuelSubcategory}
                  deleteSubcategoryApi={handleDeleteSubcategory}
                  updateSubcategoryApi={handleSaveSubcategory}
                  onEdit={handleEditSubcategory}
                  isLetter={true}
                  baseSequence={"2.5.2"}
                  index={index}
                  handleInvalidateAndReset={handleInvalidateAndReset}
                />
                {showTable === sub.id && (
                  <FuelVehicleTable
                    businessId={businessId}
                    subcategory={sub.name}
                    subcategory_description={sub.description}
                    subcategoryId={sub.id}
                  />
                )}
                <ShowHideSubTable
                  showTable={showTable}
                  setShowTable={setShowTable}
                  subId={sub.id}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default FuelVehicle;
